import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';

import { Panel } from 'primereact/panel';
import Box from '@mui/material/Box';

import Grid from '@mui/material/Grid';

import moment from "moment";

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as PartnerActions from '../../Store/Actions/Partner';


import HeaderView from '../../Components/Layout/Header';


// Load Componentes
import SideMenu from '../../Components/SideMenu';
import AlertView from '../../Components/AlertModal';


import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone
} from '../../Components/Utils';

const ufsList = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' }
];

// export default function Reservation() {
const Users = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	setUser,
	selectedUser,
	retrieveUsers,
	masterUser,
  retrieveCompanyData,
  updateCompanyData,
  retrieveCompanyBillingData, 
  updateCompanyBillingData,
  retrieveCompanyLogotype,
  updateCompanyLogotype,
  retrieveCompanyBusinessData,
  updateCompanyBusinessData,
  specialitiesList,
  servicesList,
  discountsList,
  retrieveCompanyServices,
  retrieveCompanySpecialities,
  retrieveCompanyDiscounts,  
  retrieveCompanyAddress,
  updateCompanyAddress,
  retrieveCompanyLinksAndMedia,
  updateCompanyLinksAndMedia,
  retrieveCompanyServicesLeads,
  updateCompanyServicesLeads,
} = props;

// Set Overlay obj
const op = React.useRef(null);

const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 

const [termsModal, setTermsModal] = React.useState(false); 

const [companyDocument, setCompanyDocument] = React.useState('07.760.188/0001-15');

const [companyLegalName, setCompanyLegalName] = React.useState('carregando...');
const [companyFantasyName, setCompanyFantasyName] = React.useState('carregando...');
const [companyEmail, setCompanyEmail] = React.useState('carregando...');
const [companyPhone, setCompanyPhone] = React.useState('carregando...');
const [companyState, setCompanyState] = React.useState('carregando...');
const [companyCity, setCompanyCity] = React.useState('carregando...');
const [personCompanyName, setPersonCompanyName] = React.useState('carregando...');
const [comission, setComission] = React.useState('Perfil 1');
const [profile, setProfile] = React.useState('carregando...');
const [credit, setCredit] = React.useState('carregando...');

const [companyStateAuto, setCompanyStateAuto] = React.useState('carregando...');
const [companyCityAuto, setCompanyCityAuto] = React.useState('carregando...');

const [personName, setPersonName] = React.useState('carregando...');
const [personDocument, setPersonDocument] = React.useState('carregando...');
const [personPhone, setPersonPhone] = React.useState('carregando...');
const [email, setEmail] = React.useState('carregando...');
const [emailConfirm, setEmailConfirm] = React.useState('carregando...');
const [password, setPassword] = React.useState('');
const [newPassword, setNewPassword] = React.useState('');
const [newPasswordConfirm, setNewPasswordConfirm] = React.useState('');

// Alert control
const [validateRegistry, setValidateRegistry] = React.useState(false); 
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

// Table row selection
const [selectedItem, setSelectedItem] = React.useState(null);


/* -------------------------------------------------------------------- */
/*  [CompanyProfile] - UI State for blocks (FAKE DATA / mock)            */
/* -------------------------------------------------------------------- */


// Company type controls conditional blocks
// clinic => oftal / optics => ótica
const [companyType, setCompanyType] = React.useState('clinic');

// Save loaders per block (individual save buttons)
const [savingBlocks, setSavingBlocks] = React.useState({
  companyData: false,
  billingData: false,
  logotype: false,
  businessData: false,
  address: false,
  linksMedia: false,
  servicesLeads: false
});

const specialitiesCatalog = [
  { label: 'Catarata', value: 'catarata' },
  { label: 'Cirurgia Refrativa', value: 'refrativa' },
  { label: 'Glaucoma', value: 'glaucoma' },
  { label: 'Retina', value: 'retina' },
  { label: 'Pediatria', value: 'pediatria' }
];

const socialMediaCatalog = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'TikTok', value: 'tiktok' }
];

const servicesCatalog = [
  { label: 'Consulta', value: 1 },
  { label: 'Cirurgia de Catarata', value: 2 },
  { label: 'Cirurgia Refrativa', value: 3 },
  { label: 'Exames', value: 4 }
];

const discountsCatalog = [
  { label: 'Lentes - 10%', value: 101 },
  { label: 'Armações - 15%', value: 102 },
  { label: 'Óculos de Sol - 12%', value: 103 }
];

// --- Block: Dados da empresa
const [companyData, setCompanyData] = React.useState({
  companyDocument: companyDocument || null,
  companyLegalName: companyLegalName || null,
  companyFantasyName: companyFantasyName || null,

  representativeDocument: personDocument || null,
  representativeName: personName || null,
  representativeEmail: email || null,
  representativePhone: personPhone || null,

  // novos (UI)
  tradingNameHelp: '',
  cnpjLockedAlert: ''
});


// --- Block: Dados de faturamento
const [billingData, setBillingData] = React.useState({
  current: {
    billingDocument: 'carregando...',
    street: 'carregando...',
    number: 'carregando...',
    complement: 'carregando...',
    neighborhood: 'carregando...',
    city: 'carregando...',
    state: 'carregando...',
    zip: 'carregando...'
  },
  newBilling: {
    billingDocument: '',
    label: '',
    streetType: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    zip: '',
    googleCoordinates: null,
    googlePlaceId: null,
  }
  
});

// --- Block: Logomarca
const [logotypeData, setLogotypeData] = React.useState({
  currentUrl: 'https://placehold.co/240x240?text=LOGO',
  file: null,
  fileName: ''
});
const logotypeInputRef = React.useRef(null);

// --- Block: Sobre o negócio
const [businessData, setBusinessData] = React.useState({
  whatsapp: '(21) 99999-9999',
  mainEmail: 'contato@empresa.com.br',
  mainPhone: '(21) 2517-4848',
  businessTypeLabel: companyType === 'clinic' ? 'Clínica / Oftalmologia' : 'Ótica',
  description: 'Descrição breve do negócio. Este texto será exibido na plataforma.',
  // clinic
  specialities: ['catarata', 'refrativa'],
  services: [1, 2],
  technicalResponsibleName: 'Dr. Fulano de Tal',
  technicalResponsibleCrm: '123456',
  technicalResponsibleCrmUf: 'RJ',
  // optics
  discounts: [101]
});

const isConsultaOftalmo = (row) => {
  // Preferir serviceKey quando existir; fallback para nome
  const key = (row?.key || '').toString().toLowerCase();
  const name = (row?.name || '').toString().toLowerCase();

  return key === 'consulta' || name.includes('consulta');
};

const getMinLeadForRow = (row) => (isConsultaOftalmo(row) ? 10 : 0);

const clampLeadQuantity = (value, min, max) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return min;
  return Math.max(min, Math.min(max, Math.trunc(n)));
};


// --- Block: Endereço principal
const buildEmptyAddress = () => ({
  id: null,
  label: null,

  street: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
  zip: '',

  fullAddress: '',
  latitude: null,
  longitude: null,
  googlePlaceId: null,

  // flags auxiliares
  hasCoordinates: false
});

const [addressData, setAddressData] = React.useState({
  current: {
    ...buildEmptyAddress(),
    // placeholder (pode manter para não “piscar” vazio antes do retrieve)
    street: 'carregando...',
    number: 'carregando...',
    complement: 'carregando...',
    neighborhood: 'carregando...',
    city: 'carregando...',
    state: 'carregando...',
    zip: 'carregando...',
    latitude: null,
    longitude: null,
    hasCoordinates: false,
  },
  newAddress: buildEmptyAddress()
});

// --- Block: Links e mídias
const [linksMediaData, setLinksMediaData] = React.useState({
  website: "",
  socialLinks: [],        // [{ type: 'instagram', url:'...' }]
  additionalPhones: [],   // ['21999999999', ...]
  additionalEmails: []    // ['a@b.com', ...]
});

// --- Block: Configuração de direcionamentos
const [servicesLeadsData, setServicesLeadsData] = React.useState([]);

const formatCurrencyBRL = (value) => {
  try {
    const n = Number(value);
    if (!Number.isFinite(n)) return '-';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
  } catch (e) {
    return '-';
  }
};

const setBlockSaving = (blockKey, isSaving) => {
  setSavingBlocks(prev => ({ ...prev, [blockKey]: isSaving }));
};

const fakeSave = (blockKey, successMessage) => {
  setBlockSaving(blockKey, true);
  setTimeout(() => {
    setBlockSaving(blockKey, false);
    setAlertTitle('Atualização realizada');
    setAlertBody(successMessage);
    setAlertAction('');
    setAlert(true);
  }, 700);
};



// Retrieve reservations
const retrieveItemsList = () => {
		
	/*var props = {
		setSaving:setSaving,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setRows,
		setLoading:setLoading,
		setTotalRecords:setTotalRecords
	}
	var data = {
	  lazyState:lazyState
	}
	retrieveUsers(data,props);*/

} // end retrieveDocumentInfo
 
 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */


// Run after mount component
React.useEffect(() => {

  // set scroll to top
  window.scrollTo(0, 1);
  
      retrieveCompanyServices();
      retrieveCompanyDiscounts();
      retrieveCompanySpecialities();
      
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 

const normalizeServicesLeadsResponse = (resp) => {
  const companyType = (resp?.type || '').toLowerCase() === 'optics' ? 'optics' : 'clinic';

  const items = Array.isArray(resp?.items) ? resp.items : [];

  const normalized = items.map((it) => ({
    id: companyType === 'optics' ? Number(it.discountCouponId) : Number(it.serviceId),
    name: companyType === 'optics' ? String(it.discountCouponName || it.discountCouponKey || '—') : String(it.serviceName || it.serviceKey || '—'),
    key: companyType === 'optics' ? (it.discountCouponKey || null) : (it.serviceKey || null),

    // quantidades
    leadMinQuantity: Number(it.leadMinQuantity) || 0,
    quantity: Number(it.leadMaxQuantity) || 0, // <-- editável no input
    leadMaxQuantity: Number(it.leadMaxQuantity) || 0,

    // preço por lead (o que você quer mostrar na tabela)
    perLeadPrice: (it.perLeadPrice === null || it.perLeadPrice === undefined) ? null : Number(it.perLeadPrice),

    // extras (não editáveis aqui, mas úteis se quiser exibir depois)
    servicePriceOf: it.servicePriceOf ?? null,
    servicePriceFor: it.servicePriceFor ?? null,
    discountPercentage: it.discountPercentage ?? null,
    validFrom: it.validFrom ?? null,
    validTo: it.validTo ?? null,
    status: it.status ?? 1,
  }));

  return { companyType, items: normalized };
};


React.useEffect(() => {

  setBlockSaving('companyData', true);

  retrieveCompanyData({
  setSuccess: (payload) => {
    const companyApi = payload?.company || {};
    const repApi = payload?.representative || {};

    setCompanyData((prev) => ({
      ...prev,
      companyDocument: companyApi?.cnpj || prev.companyDocument,
      companyLegalName: companyApi?.legalName || prev.companyLegalName,
      companyFantasyName: companyApi?.tradingName || prev.companyFantasyName,

      representativeDocument: repApi?.cpf || prev.representativeDocument,
      representativeName: repApi?.name || prev.representativeName,
      representativeEmail: repApi?.email || prev.representativeEmail,
      representativePhone: repApi?.mobilePhone || prev.representativePhone,

      // mensagens auxiliares do endpoint (para UI)
      tradingNameHelp: companyApi?.tradingNameHelp || prev.tradingNameHelp,
      cnpjLockedAlert: companyApi?.cnpjLockedAlert || prev.cnpjLockedAlert,
    }));

    setBlockSaving('companyData', false);
  },
  setError: (message) => {
    setBlockSaving('companyData', false);
    setAlertTitle('Atenção');
    setAlertBody(message);
    setAlert(true);
  }
});

// ------------------------------------------------------------------
// BLOCO 2 - Carrega dados reais de faturamento
// ------------------------------------------------------------------
setBlockSaving('billingData', true);

retrieveCompanyBillingData({
  setSuccess: (resp) => {
    const addr = resp?.billingAddress || null;
    const doc = resp?.billingDocument || null;

    setBillingData(prev => ({
      ...prev,
      current: {
        billingDocument: doc?.value ? maskCNPJ(doc.value) : '',
        label: addr?.label || 'Endereço de Cobrança',

        streetType: addr?.streetType || '',
        street: addr?.streetName || '',
        number: addr?.streetNumber || '',
        complement: addr?.streetComplement || '',
        neighborhood: addr?.suburb || '',
        city: addr?.city || '',
        state: addr?.state || '',
        zip: addr?.postalCode || '',

        country: addr?.country || 'BR',
        fullAddress: addr?.fullAddress || '',
        googleCoordinates: addr?.googleCoordinates || null,
        googlePlaceId: addr?.googlePlaceId || null,
      }
    }));    

    setBlockSaving('billingData', false);
  },
  setError: (message) => {
    setBlockSaving('billingData', false);
    setAlertTitle('Atenção');
    setAlertBody(message);
    setAlert(true);
  }
});


setBlockSaving('logotype', true);

retrieveCompanyLogotype({
  setSuccess: (res) => {

    let data = res.data;

    console.log('[data]--------->]'+JSON.stringify(data, null, 2));

    setLogotypeData(prev => ({
      ...prev,
      currentUrl: data?.data.url || prev.currentUrl,
      fileName: data?.data.fileName || '',
      hasLogotype: !!data?.data.hasLogotype,
      placeholder: !!data?.data.placeholder,
      file: null // garante que não fica seleção antiga
    }));

    setBlockSaving('logotype', false);
  },
  setError: (message) => {
    setBlockSaving('logotype', false);
    setAlertTitle('Atenção');
    setAlertBody(message);
    setAlert(true);
  }
});

// ------------------------------------------------------------------
// BLOCO 4 - Carrega dados reais do negócio
// ------------------------------------------------------------------
setBlockSaving('businessData', true);

retrieveCompanyBusinessData({
  setSuccess: (data) => {
    // data aqui é o "result.data" do action (ou seja, o objeto interno)
    // Se no seu action você estiver passando o response inteiro, ajuste para (resp) => { const data = resp?.data || resp; }

    // companyType (clinic | optics)
    const companyTypeApi = data?.companyType || 'clinic';
    setCompanyType(companyTypeApi);

    // Especialidades: API => [{SystemRepoCompanySpecialityId, type}]
    const specialityIds = Array.isArray(data?.specialities)
      ? data.specialities.map(s => Number(s.SystemRepoCompanySpecialityId)).filter(Boolean)
      : [];

    // Serviços / descontos já vêm como array de ids numéricos
    const serviceIds = Array.isArray(data?.services) ? data.services.map(Number) : [];
    const discountIds = Array.isArray(data?.discounts) ? data.discounts.map(Number) : [];

    // Responsável técnico
    const tr = data?.tecnicalResponsible || null;

    setBusinessData(prev => ({
      ...prev,
      // inputs
      whatsapp: data?.whatsappPhone ? maskPhone(data.whatsappPhone) : '',
      mainEmail: data?.mainEmail || '',
      mainPhone: data?.mainPhone ? maskPhone(data.mainPhone) : prev.mainPhone, // se existir no futuro

      description: data?.description || '',

      // condicionais
      businessTypeLabel: companyTypeApi === 'clinic' ? 'Clínica / Oftalmologia' : 'Ótica',

      specialities: specialityIds,
      services: serviceIds,
      discounts: discountIds,

      technicalResponsibleName: tr?.name || '',
      technicalResponsibleCrm: tr?.document || '',
      technicalResponsibleCrmUf: tr?.documentState || '',
    }));

    setBlockSaving('businessData', false);
  },
  setError: (message) => {
    setBlockSaving('businessData', false);
    setAlertTitle('Atenção');
    setAlertBody(message);
    setAlert(true);
  }
});

// ------------------------------------------------------------------
// BLOCO 5 - Carrega endereço principal (CompanyAddress)
// ------------------------------------------------------------------
setBlockSaving('address', true);

retrieveCompanyAddress({
  setSuccess: (resp) => {
    // resp: { success:true, found:boolean, data:null|object }
    const found = !!resp?.found;
    const a = resp?.data || null;

    const parsed = found && a ? {
      id: a.id || null,
      label: a.label || null,

      street: a.streetName || '',
      number: a.streetNumber || '',
      complement: a.streetComplement || '',
      neighborhood: a.suburb || '',
      city: a.city || '',
      state: a.state || '',
      zip: a.postalCode || '',

      fullAddress: a.fullAddress || '',
      latitude: a.latitude ?? null,
      longitude: a.longitude ?? null,
      googlePlaceId: a.googlePlaceId || null,

      hasCoordinates: (a.latitude != null && a.longitude != null)
    } : buildEmptyAddress();

    setAddressData(prev => ({
      ...prev,
      current: parsed,
      newAddress: buildEmptyAddress() // formulário começa limpo (padrão “Substituir”)
      // se você preferir já copiar current -> newAddress, troque por: newAddress: { ...parsed }
    }));

    setBlockSaving('address', false);
  },
  setError: (message) => {
    setBlockSaving('address', false);
    setAlertTitle('Atenção');
    setAlertBody(message);
    setAlert(true);
  }
});

// ------------------------------------------------------------------
// BLOCO 6 - Links e mídias
// ------------------------------------------------------------------
setBlockSaving("linksMedia", true);

retrieveCompanyLinksAndMedia({
  setSuccess: (resp) => {
    const data = resp?.data || {};

    const website = data?.companyWebsite || "";

    const socialLinks = (data?.companySocialMedia || []).map((item) => ({
      type: item?.key || "",
      url: item?.value || "",
      // você pode armazenar o id se quiser, mas o backend é replace-all, então não precisa
      // id: item?.id || null
    }));

    const additionalPhones = (data?.companyExtraPhones || []).map((p) => {
      // backend já pode devolver só dígitos; mantém como string
      return String(p?.value || "");
    });

    const additionalEmails = (data?.companyExtraEmail || []).map((m) => {
      return String(m?.value || "").trim().toLowerCase();
    });

    setLinksMediaData({
      website,
      socialLinks,
      additionalPhones,
      additionalEmails
    });

    setBlockSaving("linksMedia", false);
  },
  setError: (message) => {
    setBlockSaving("linksMedia", false);
    setAlertTitle("Atenção");
    setAlertBody(message);
    setAlert(true);
  },
});


// ------------------------------------------------------------------
// BLOCO 7 - Carrega configuração de direcionamentos (por serviço/cupom)
// ------------------------------------------------------------------
setBlockSaving('servicesLeads', true);

retrieveCompanyServicesLeads({
  setSuccess: (resp) => {
    const { companyType: ct, items } = normalizeServicesLeadsResponse(resp);

    setCompanyType(ct);
    setServicesLeadsData(items);

    setBlockSaving('servicesLeads', false);
  },
  setError: (msg) => {
    setBlockSaving('servicesLeads', false);
    setAlertTitle('Atenção');
    setAlertBody(msg || 'Falha ao carregar direcionamentos.');
    setAlert(true);
  },
});


  // eslint-disable-next-line
}, []);




// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "20px" : "40px",marginTop:"4px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "" : "64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Dados da Empresa</div>
								
							
							</div>
							
							
							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>
			
									<Box
									  sx={{
										width: isMobile ? "100%" : "80%",
										padding:"50px"
									  }}
									>
                    <div className="registerModalIntro">
                      <i>
                        Só é possível atualizar o <b>Nome Fantasia</b>. <br />
                        Caso precise atualizar outra informação, entre em contato com o suporte.
                      </i>
                    </div>
										<Divider />

								
{/* -------------------------------------------------------------------- */}
{/*  BLOCO 1 - Dados da empresa                                          */}
{/* -------------------------------------------------------------------- */}
<Panel header="Dados da empresa" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>
    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText id="companyDataCnpj" autoComplete="new-password" disabled={true} className="w100" value={maskCNPJ(companyData.companyDocument || '')} />
        <label htmlFor="companyDataCnpj">CNPJ</label>
      </div>
      <small className="tAlignL w100 dBlock" style={{marginTop:"0.35rem"}}>
        <i className="pi pi-exclamation-triangle" style={{color:"orange",marginRight:"5px"}}></i>
        {companyData.cnpjLockedAlert || 'O CNPJ não pode ser alterado.'}
      </small>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText id="companyDataLegalName" autoComplete="new-password" disabled={true} className="w100" value={companyData.companyLegalName} />
        <label htmlFor="companyDataLegalName">Razão Social</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText
          id="companyDataFantasyName"
          autoComplete="new-password"
          disabled={savingBlocks.companyData}
          className="w100"
          value={companyData.companyFantasyName}
          onChange={(e) => setCompanyData(prev => ({...prev, companyFantasyName: e.target.value}))}
          tooltip="Este será o nome visível na plataforma (exibição pública)."
          tooltipOptions={{ position: 'bottom', event: 'focus' }}
        />
        <label htmlFor="companyDataFantasyName">Nome Fantasia</label>
      </div>
      <small className="tAlignL w100 dBlock" style={{marginTop:"0.35rem"}}>
        {companyData.tradingNameHelp || 'Este será o nome visível na plataforma. Se vazio mostraremos a razão social.'}
      </small>   
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText id="companyDataRepCpf" autoComplete="new-password" disabled={true} className="w100" value={maskCPF(companyData.representativeDocument || '')} />
        <label htmlFor="companyDataRepCpf">CPF do representante</label>
      </div>
      <small className="tAlignL w100 dBlock" style={{marginTop:"0.35rem"}}>
        <i className="pi pi-exclamation-triangle" style={{color:"orange",marginRight:"5px"}}></i>
        Não é possível alterar o CPF por aqui. Se precisar alterar, entre em contato com o suporte.
      </small>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText id="companyDataRepName" autoComplete="new-password" disabled={true} className="w100" value={companyData.representativeName} />
        <label htmlFor="companyDataRepName">Nome do representante</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText id="companyDataRepEmail" autoComplete="new-password" disabled={true} className="w100" value={companyData.representativeEmail} />
        <label htmlFor="companyDataRepEmail">Email do representante</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText id="companyDataRepPhone" autoComplete="new-password" disabled={true} className="w100"  value={maskPhone(companyData.representativePhone || '')} />
        <label htmlFor="companyDataRepPhone">Celular do representante</label>
      </div>
      <small className="tAlignL w100 dBlock" style={{marginTop:"0.35rem"}}>
        <i className="pi pi-info-circle" style={{color:"#2E0249",marginRight:"5px"}}></i>
        Senha pode ser alterada pelo próprio usuário no perfil.
      </small>
    </Grid>
  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">
      <Button
        label="Gravar alterações"
        icon="pi pi-check"
        loading={savingBlocks.companyData}
//        onClick={() => fakeSave('companyData', 'Nome fantasia atualizado com sucesso.')}

        onClick={() => {
          setBlockSaving('companyData', true);

          const fantasy = (companyData.companyFantasyName || '').trim();
          if (!fantasy) {
            setBlockSaving('companyData', false);
            setAlertTitle('Atenção');
            setAlertBody('Informe um Nome Fantasia válido.');
            setAlert(true);
            return;
          }

          const payload = {
            tradingName: (companyData.companyFantasyName || '').trim()
          };

          updateCompanyData(payload, {
            setSuccess: () => {
              setBlockSaving('companyData', false);
              setAlertTitle('Atualização realizada');
              setAlertBody('Nome fantasia atualizado com sucesso.');
              setAlert(true);
            },
            setError: (message) => {
              setBlockSaving('companyData', false);
              setAlertTitle('Atenção');
              setAlertBody(message);
              setAlert(true);
            }
          });
        }}

      />
    </div>
  </div>
</Panel>


{/* -------------------------------------------------------------------- */}
{/*  BLOCO 3 - Logomarca                                                 */}
{/* -------------------------------------------------------------------- */}
<Panel header="Logomarca" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>
    <Grid item xs={12} sm={5}>
      <Card title="Logomarca atual" style={{width:'100%', boxShadow:'none', border:'1px solid #eee'}}>
        <img
          src={logotypeData.file ? URL.createObjectURL(logotypeData.file) : logotypeData.currentUrl}
          alt="Logomarca"
          style={{width:'100%', maxWidth:'240px', borderRadius:'8px'}}
        />
        {logotypeData.fileName && (
          <div className="tAlignL" style={{marginTop:'0.8rem', fontSize:'0.9rem'}}><b>Arquivo:</b> {logotypeData.fileName}</div>
        )}
      </Card>
    </Grid>

    <Grid item xs={12} sm={7}>
      <div className="tAlignL" style={{fontWeight:600, marginBottom:'0.5rem'}}>Enviar nova logomarca</div>
      <div className="tAlignL" style={{marginBottom:'0.75rem'}}>
        <small>
          Selecione um arquivo JPEG, JPG ou PNG com até 5MB. Tamanho mínimo recomendado: 120x120 pixels.
        </small>
      </div>
      <input
        type="file"
        ref={logotypeInputRef}
        accept="image/jpeg,image/jpg,image/png,image/webp"
        onChange={(e) => {
          const file = e.target?.files?.[0];
          if (!file) return;
          setLogotypeData(prev => ({...prev, file, fileName: file.name}));
        }}
        style={{display:'none'}}
      />
      <div style={{display:'flex', flexDirection: isMobile ? 'column' : 'row', gap:'10px', alignItems:'center'}}>
        <Button
          label="Selecionar arquivo"
          outlined
          icon="pi pi-upload"
          disabled={savingBlocks.logotype}
          onClick={() => logotypeInputRef.current?.click()}
        />
        <Button
          label="Remover seleção"
          icon="pi pi-times"
          severity="danger"
          text
          disabled={savingBlocks.logotype || !logotypeData.file}

          onClick={() => {
            setLogotypeData(prev => ({...prev, file: null, fileName: ''}));
            if (logotypeInputRef.current) logotypeInputRef.current.value = '';
          }}

        />
      </div>
    </Grid>
  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">
      <Button
        label="Gravar alterações"
        icon="pi pi-check"
        loading={savingBlocks.logotype}
        disabled={!logotypeData.file}

        onClick={() => {
            const file = logotypeData?.file;

            if (!file) return;

            // validações simples (frontend) — backend valida extensão também
            const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
            if (!allowed.includes(file.type)) {
              setAlertTitle('Atenção');
              setAlertBody('Formato inválido. Envie JPG, JPEG, PNG ou WEBP.');
              setAlert(true);
              return;
            }

            const maxBytes = 5 * 1024 * 1024; // 5MB
            if (file.size > maxBytes) {
              setAlertTitle('Atenção');
              setAlertBody('Arquivo muito grande. Envie uma imagem de até 5MB.');
              setAlert(true);
              return;
            }

            setBlockSaving('logotype', true);

            updateCompanyLogotype(file, {
              setSuccess: (data) => {
                // atualiza URL e limpa seleção
                setLogotypeData(prev => ({
                  ...prev,
                  currentUrl: data?.url || prev.currentUrl,
                  fileName: data?.fileName || prev.fileName,
                  file: null
                }));

                // limpa o input
                if (logotypeInputRef.current) logotypeInputRef.current.value = '';

                setBlockSaving('logotype', false);
                setAlertTitle('Atualização realizada');
                setAlertBody('Logomarca atualizada com sucesso.');
                setAlert(true);
              },
              setError: (message) => {
                setBlockSaving('logotype', false);
                setAlertTitle('Atenção');
                setAlertBody(message);
                setAlert(true);
              }
            });
          }}        
        
      />
    </div>
  </div>
</Panel>

{/* -------------------------------------------------------------------- */}
{/*  BLOCO 4 - Sobre o negócio                                           */}
{/* -------------------------------------------------------------------- */}
<Panel header="Sobre o negócio" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>
    <Grid item xs={12} sm={4}>
      <span className="p-float-label">
        <InputText id="businessWhatsapp" disabled={savingBlocks.businessData} value={businessData.whatsapp} onChange={(e) => setBusinessData(prev => ({...prev, whatsapp: maskPhone(e.target.value)}))} className="w100" />
        <label htmlFor="businessWhatsapp">Telefone WhatsApp</label>
      </span>
    </Grid>
    <Grid item xs={12} sm={4}>
      <span className="p-float-label">
        <InputText id="businessMainEmail" disabled={savingBlocks.businessData} value={businessData.mainEmail} onChange={(e) => setBusinessData(prev => ({...prev, mainEmail: e.target.value}))} className="w100" />
        <label htmlFor="businessMainEmail">Email principal</label>
      </span>
    </Grid>
    <Grid item xs={12} sm={4}>
      <span className="p-float-label">
        <InputText id="businessMainPhone" disabled={savingBlocks.businessData} value={businessData.mainPhone} onChange={(e) => setBusinessData(prev => ({...prev, mainPhone: maskPhone(e.target.value)}))} className="w100" />
        <label htmlFor="businessMainPhone">Telefone principal</label>
      </span>
    </Grid>

    <Grid item xs={12} sm={6}>
      <span className="p-float-label">
        <InputText id="businessType" disabled={true} value={businessData.businessTypeLabel} className="w100" />
        <label htmlFor="businessType">Tipo de negócio</label>
      </span>
    </Grid>

    <Grid item xs={12} sm={12}>
      <span className="p-float-label">
        <InputTextarea id="businessDescription" rows={5} disabled={savingBlocks.businessData} value={businessData.description} onChange={(e) => setBusinessData(prev => ({...prev, description: e.target.value}))} className="w100" />
        <label htmlFor="businessDescription">Descrição do negócio</label>
      </span>
    </Grid>

    {companyType === 'clinic' && (
      <>
        <Grid item xs={12} sm={6}>
          <span className="p-float-label">
            <MultiSelect
                id="serviceCategories"
                inputId="businessSpecialities"
                tabIndex={5} 
                value={businessData.specialities || []}
                options={specialitiesList}
                onChange={(e) => setBusinessData(prev => ({...prev, specialities: e.value}))}                           
                optionLabel="name"
                optionValue="id"
                placeholder="Selecione ao menos uma subespecialidade"
                className="w100 customChipWrapper"
                display="comma"
                selectedItemTemplate={(value) => {
                  const category = specialitiesList.find(s => s.id === value);
                  const label = category?.name || null;
                  if (!label) return null;
                  return (
                    <div className="customChip">
                    <span className="content">{label}</span>
                  </div>
                  );
                }}                            
              />

            <label htmlFor="businessSpecialities">Especialidades</label>
          </span>
        </Grid>

        <Grid item xs={12} sm={6}>
          <span className="p-float-label">

            <MultiSelect
              id="servicesOffered"
              inputId="businessServices"
              tabIndex={6} 
              value={businessData.services || []}
              options={servicesList?.map(s => ({ label: s.name, value: s.id }))}
              onChange={(e) => {
                const selectedValues = e.value || [];
                const mandatoryServices = servicesList
                  .filter(service => service.category?.type === 'service' && service.required)
                  .map(service => service.id);
                            
                const finalSelectedValues = Array.from(new Set([...selectedValues, ...mandatoryServices]));
                
                const selectedServiceData = servicesList.filter(service =>
                  selectedValues.includes(service.id)
                ).map(service => ({
                  label: service.name,
                  value: service.id0
                }));
              
                setBusinessData(prev => ({...prev, services: finalSelectedValues}))

              }}                                                                                    
              optionLabel="label"
              optionValue="value"
              selectedItemTemplate={(value) => {
                const service = servicesList.find(s => s.id === value);
                const label = service?.name || value;
                const isRequired = service?.required;
              
                return (
                  <div className={`customChip ${isRequired ? 'requiredChip' : ''}`}>
                    <span className="content">{label}</span>
                    {isRequired ? (<span className="badge">Obrigatório</span>) : null}
                  </div>
                );
              }}
              placeholder="Selecione um ou mais serviços"
              className="w100 customChipWrapper"
              display="comma"
            />

            <label htmlFor="businessServices">Serviços oferecidos</label>
          </span>
        </Grid>

        <Grid item xs={12} sm={6}>
          <span className="p-float-label">
            <InputText id="businessTechName" disabled={savingBlocks.businessData} value={businessData.technicalResponsibleName} onChange={(e) => setBusinessData(prev => ({...prev, technicalResponsibleName: e.target.value}))} className="w100" />
            <label htmlFor="businessTechName">Nome do Responsável Técnico</label>
          </span>
        </Grid>
        <Grid item xs={12} sm={3}>
          <span className="p-float-label">
            <InputText id="businessTechCrm" disabled={savingBlocks.businessData} value={businessData.technicalResponsibleCrm} onChange={(e) => setBusinessData(prev => ({...prev, technicalResponsibleCrm: e.target.value}))} className="w100" />
            <label htmlFor="businessTechCrm">CRM</label>
          </span>
        </Grid>
        <Grid item xs={12} sm={3}>
          <span className="p-float-label">
            {/*<InputText id="businessTechCrmUf" disabled={savingBlocks.businessData} value={businessData.technicalResponsibleCrmUf} onChange={(e) => setBusinessData(prev => ({...prev, technicalResponsibleCrmUf: e.target.value.toUpperCase()}))} className="w100" />*/}

            <Dropdown
              id="businessTechCrmUf"
              tabIndex={11} 
              disabled={savingBlocks.businessData} 
              value={businessData.technicalResponsibleCrmUf} 
              onChange={(e) => setBusinessData(prev => ({...prev, technicalResponsibleCrmUf: e.target.value.toUpperCase()}))} 
              options={ufsList}
              placeholder="UF do CRM"
              style={{ width: "100%", textAlign:"left" }}
            />

            <label htmlFor="businessTechCrmUf">UF do CRM</label>
          </span>
        </Grid>
      </>
    )}

    {companyType === 'optics' && (
      <>
        <Grid item xs={12} sm={6}>
          <span className="p-float-label">
            <MultiSelect
              inputId="businessDiscounts"
              value={businessData.discounts}
              options={discountsCatalog}
              onChange={(e) => setBusinessData(prev => ({...prev, discounts: e.value}))}
              disabled={savingBlocks.businessData}
              className="w100"
              display="chip"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione"
            />
            <label htmlFor="businessDiscounts">Descontos oferecidos</label>
          </span>
        </Grid>
        <Grid item xs={12} sm={6}>
          <span className="p-float-label">
            <InputText id="businessOpticsTechName" disabled={savingBlocks.businessData} value={businessData.technicalResponsibleName} onChange={(e) => setBusinessData(prev => ({...prev, technicalResponsibleName: e.target.value}))} className="w100" />
            <label htmlFor="businessOpticsTechName">Nome do Responsável Técnico</label>
          </span>
        </Grid>
      </>
    )}
  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">

    <Button
      label="Gravar alterações"
      icon="pi pi-check"
      loading={savingBlocks.businessData}
      onClick={() => {
        // -----------------------
        // validações básicas
        // -----------------------
        const whatsappDigits = String(businessData.whatsapp || '').replace(/\D/g, '');
        const mainPhoneDigits = String(businessData.mainPhone || '').replace(/\D/g, '');

        if (!whatsappDigits || whatsappDigits.length < 10) {
          setAlertTitle('Atenção');
          setAlertBody('Informe um WhatsApp válido.');
          setAlert(true);
          return;
        }

        if (!businessData.mainEmail || !validarEmail(String(businessData.mainEmail).trim())) {
          setAlertTitle('Atenção');
          setAlertBody('Informe um e-mail principal válido.');
          setAlert(true);
          return;
        }

        // descrição pode ser vazia (backend aceita), mas se quiser exigir:
        // if (!String(businessData.description || '').trim()) ...

        // responsável técnico (backend exige se enviar qualquer campo)
        const techName = String(businessData.technicalResponsibleName || '').trim();

        if (!techName) {
          setAlertTitle('Atenção');
          setAlertBody('Informe o nome do Responsável Técnico.');
          setAlert(true);
          return;
        }

        if (companyType === 'clinic') {
          const crm = String(businessData.technicalResponsibleCrm || '').trim();
          const uf = String(businessData.technicalResponsibleCrmUf || '').trim().toUpperCase();

          if (!crm) {
            setAlertTitle('Atenção');
            setAlertBody('Informe o CRM do Responsável Técnico.');
            setAlert(true);
            return;
          }

          if (!uf || uf.length !== 2) {
            setAlertTitle('Atenção');
            setAlertBody('Informe a UF do CRM com 2 letras (ex: RJ).');
            setAlert(true);
            return;
          }
        }

        // -----------------------
        // monta payload do PUT
        // -----------------------
        const payload = {
          whatsappPhone: whatsappDigits,
          mainEmail: String(businessData.mainEmail).trim().toLowerCase(),
          businessDescription: String(businessData.description || '').trim(),

          tecnicalResponsibleName: techName
        };

        if (companyType === 'clinic') {

          // payload.companySpecialities = Array.isArray(businessData.specialities) ? businessData.specialities : [];
          // payload.companyServices = Array.isArray(businessData.services) ? businessData.services : [];

          payload.companySpecialities = Array.isArray(businessData.specialities)
            ? businessData.specialities.map(Number).filter(Boolean)
            : [];

          payload.companyServices = Array.isArray(businessData.services)
            ? businessData.services.map(Number).filter(Boolean)
            : [];          

          payload.tecnicalResponsibleDocument = String(businessData.technicalResponsibleCrm || '').trim();
          payload.tecnicalResponsibleDocumentState = String(businessData.technicalResponsibleCrmUf || '').trim().toUpperCase();

        } else {

           // payload.companyDiscountCoupons = Array.isArray(businessData.discounts) ? businessData.discounts : [];
          // optics: backend zera document/documentState internamente

          payload.companyDiscountCoupons = Array.isArray(businessData.discounts)
            ? businessData.discounts.map(Number).filter(Boolean)
            : [];                 

        }


        setBlockSaving('businessData', true);

        updateCompanyBusinessData(payload, {

          setSuccess: (resp) => {
            // Se seu action já passa só "result.data", então use: const data = resp || {};
            // Se passa o response inteiro: const data = resp?.data || {};
            const data = resp?.data || resp || {};

            const apiCompanyType = data?.companyType || companyType;
            setCompanyType(apiCompanyType);

            // ids numéricos SEMPRE
            const specialityIds = Array.isArray(data?.specialities)
              ? data.specialities
                  .map((s) => Number(s?.SystemRepoCompanySpecialityId))
                  .filter(Boolean)
              : [];

            const serviceIds = Array.isArray(data?.services)
              ? data.services.map(Number).filter(Boolean)
              : [];

            const discountIds = Array.isArray(data?.discounts)
              ? data.discounts.map(Number).filter(Boolean)
              : [];

            const tr = data?.tecnicalResponsible || null;

            setBusinessData((prev) => ({
              ...prev,

              whatsapp: data?.whatsappPhone ? maskPhone(data.whatsappPhone) : prev.whatsapp,
              mainEmail: data?.mainEmail || prev.mainEmail,
              mainPhone: data?.mainPhone ? maskPhone(data.mainPhone) : prev.mainPhone,
              description: data?.description ?? prev.description,

              businessTypeLabel: apiCompanyType === 'clinic' ? 'Clínica / Oftalmologia' : 'Ótica',

              // IMPORTANTÍSSIMO: manter arrays numéricos
              specialities: apiCompanyType === 'clinic' ? specialityIds : [],
              services: apiCompanyType === 'clinic' ? serviceIds : [],
              discounts: apiCompanyType === 'optics' ? discountIds : [],

              technicalResponsibleName: tr?.name || '',
              technicalResponsibleCrm: tr?.document || '',
              technicalResponsibleCrmUf: tr?.documentState || '',
            }));

            setBlockSaving('businessData', false);

            // ------------------------------------------------------------
            // [BLOCO 4 -> BLOCO 7] Recarrega direcionamentos após alterar serviços
            // ------------------------------------------------------------
            if (retrieveCompanyServicesLeads) {
              retrieveCompanyServicesLeads({
                setSuccess: (respLeads) => {
                  // Se você já tem o helper normalizeServicesLeadsResponse, use ele:
                  if (typeof normalizeServicesLeadsResponse === "function") {
                    const { companyType: ct, items } = normalizeServicesLeadsResponse(respLeads);
                    setCompanyType(ct);
                    setServicesLeadsData(items);
                    return;
                  }

                  // Fallback (caso não exista normalizeServicesLeadsResponse)
                  const ct = (respLeads?.type || "clinic").toLowerCase();
                  const items = Array.isArray(respLeads?.items) ? respLeads.items : [];

                  setCompanyType(ct);
                  setServicesLeadsData(
                    items.map((it) => ({
                      id: ct === "optics" ? it.discountCouponId : it.serviceId,
                      key: it.serviceKey || it.discountCouponKey || null,
                      name: it.serviceName || it.discountCouponName || "-",
                      quantity: Number(it.leadMaxQuantity ?? 0),
                      perLeadPrice: Number(it.perLeadPrice ?? 0),
                      leadMinQuantity: Number(it.leadMinQuantity ?? 0),
                      leadMaxQuantity: Number(it.leadMaxQuantity ?? 0),
                      status: it.status ?? 1,
                    }))
                  );
                },
                setError: (msg) => {
                  // Não bloqueia o fluxo do BLOCO 4 — apenas informa.
                  console.log("Falha ao recarregar BLOCO 7:", msg);

                  // Se você quiser alertar o usuário:
                  // setAlertTitle('Atenção');
                  // setAlertBody(msg || 'Falha ao recarregar configuração de direcionamentos.');
                  // setAlert(true);
                },
              });
            }

            setAlertTitle('Atualização realizada');
            setAlertBody(companyType === 'clinic'
              ? 'Dados do negócio atualizados com sucesso. Se você alterou serviços, revise também a “Configuração de Direcionamentos” para definir a quantidade máxima de serviços.'
              :  'Dados do negócio atualizados com sucesso. Se você alterou descontos, revise também a “Configuração de Direcionamentos” para definir a quantidade máxima de descontos.'
            );
            setAlert(true);
          },
          setError: (message) => {
            setBlockSaving('businessData', false);
            setAlertTitle('Atenção');
            setAlertBody(message);
            setAlert(true);
          }
        });
      }}
    />


    </div>
  </div>
</Panel>


{/* -------------------------------------------------------------------- */}
{/*  BLOCO 7 - Configuração de direcionamentos                           */}
{/* -------------------------------------------------------------------- */}
<Panel header="Configuração de Direcionamentos" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>

    <Grid item xs={12}>
      <small className="tAlignL dBlock" style={{marginBottom:'0.5rem'}}>
        <i className="pi pi-info-circle" style={{color:"#2E0249",marginRight:"5px"}}></i>
        Para não receber direcionamentos de um serviço, defina a quantidade como <b>0</b>. Se preferir remover um serviço do seu escopo, ajuste em <b>“Sobre o negócio”</b>.
      </small>
    </Grid>

    <Grid item xs={12}>
      <Card style={{boxShadow:'none', border:'1px solid #eee'}}>
        <div style={{overflowX:'auto'}}>
          <table className="w100" style={{borderCollapse:'collapse'}}>

          <thead>
            <tr style={{textAlign:'left', borderBottom:'1px solid #eee'}}>
              <th style={{padding:'12px'}}>Serviço</th>
              <th style={{padding:'12px', width:'180px'}}>Valor / direcionamento</th>
              <th style={{padding:'12px', width:'220px'}}>Qtd. / mês</th>
            </tr>
          </thead>

          <tbody>
            {servicesLeadsData.map((row, index) => (
              <tr key={row.id} style={{borderBottom:'1px solid #f2f2f2'}}>
                <td style={{padding:'12px'}}>
                  {row.name}
                </td>

                <td style={{padding:'12px'}}>
                  {formatCurrencyBRL(row.perLeadPrice)}
                </td>

                <td style={{padding:'12px'}}>
                  
                  {/* <InputText
                    value={String(row.quantity)}
                    disabled={savingBlocks.servicesLeads}
                    className="w100"
                    onChange={(e) => {
                      const valueRaw = e.target.value;
                      const value = valueRaw.replace(/[^\d]/g, '');
                      setServicesLeadsData(prev => {
                        const list = [...prev];
                        list[index] = { ...list[index], quantity: value === '' ? 0 : parseInt(value, 10) };
                        return list;
                      });
                    }}
                    tooltip="Defina a quantidade mensal de direcionamentos para este serviço."
                    tooltipOptions={{ position: 'bottom', event: 'focus' }}
                  />*/}

                  <InputNumber
                    value={Number(row.quantity) ?? 0}
                    onValueChange={(e) => {
                      const min = getMinLeadForRow(row);
                      const max = 1000;

                      const next = clampLeadQuantity(e.value ?? min, min, max);

                      setServicesLeadsData(prev => {
                        const list = [...prev];
                        list[index] = { ...list[index], quantity: next };
                        return list;
                      });
                    }}
                    showButtons
                    buttonLayout="horizontal"
                    min={getMinLeadForRow(row)}
                    max={1000}
                    disabled={savingBlocks.servicesLeads}
                    className="w100"
                    inputStyle={{ width: "100%", textAlign: "center" }}
                    placeholder="Qtd"
                    tooltip={"Defina 0 para não receber direcionamentos deste serviço (máximo 1000). Com exceção os que tem um mínimo definido."}
                    tooltipOptions={{ position: 'bottom', event: 'focus' }}
                  />
                  
                </td>
              </tr>
            ))}
          </tbody>

          </table>
        </div>
        
      </Card>
      
    </Grid>
  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">
      <Button
        label="Gravar alterações"
        icon="pi pi-check"
        loading={savingBlocks.servicesLeads}
        onClick={() => {
          // validações mínimas
          const invalid = (servicesLeadsData || []).some(r => {
            const q = Number(r.quantity);
            return !Number.isFinite(q) || q < 0;
          });

          if (invalid) {
            setAlertTitle('Atenção');
            setAlertBody('A quantidade deve ser um número inteiro maior ou igual a zero.');
            setAlert(true);
            return;
          }

          setBlockSaving('servicesLeads', true);

          const MAX_QTY = 1000;

          // aplica clamp definitivo em tudo antes de enviar
          const sanitizedList = (servicesLeadsData || []).map(r => {
            const min = getMinLeadForRow(r);
            const nextQty = clampLeadQuantity(r.quantity, min, MAX_QTY);
            return { ...r, quantity: nextQty };
          });

          const invalidConsulta = sanitizedList.some(r => isConsultaOftalmo(r) && Number(r.quantity) < 10);
          if (invalidConsulta) {
            setAlertTitle('Atenção');
            setAlertBody('Consulta com oftalmologista deve ter no mínimo 10 direcionamentos por mês.');
            setAlert(true);
            return;
          }          

          // se houve ajuste, rehidrata state (opcional, mas recomendado para UX consistente)
          setServicesLeadsData(sanitizedList);

          // monta payload com base na lista sanitizada
          const items = sanitizedList.map(r => {
            const leadMaxQuantity = Math.trunc(Number(r.quantity) || 0);
            if (companyType !== 'optics') return { serviceId: r.id, leadMaxQuantity };
            return { discountCouponId: r.id, leadMaxQuantity };
          });          

          updateCompanyServicesLeads(
            { items },
            {
              setSuccess: (resp) => {
                const { companyType: ct, items } = normalizeServicesLeadsResponse(resp);

                setCompanyType(ct);
                setServicesLeadsData(items);

                setBlockSaving('servicesLeads', false);

                setAlertTitle('Sucesso');
                setAlertBody(resp?.message || 'Configuração de direcionamentos atualizada com sucesso.');
                setAlert(true);
              },
              setError: (msg) => {
                setBlockSaving('servicesLeads', false);
                setAlertTitle('Atenção');
                setAlertBody(msg || 'Falha ao atualizar direcionamentos.');
                setAlert(true);
              }
            }
          );
        }}

      />
    </div>
  </div>
</Panel>

{/* -------------------------------------------------------------------- */}
{/*  BLOCO 5 - Endereço                                                  */}
{/* -------------------------------------------------------------------- */}
<Panel header="Endereço" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>
    <Grid item xs={12} sm={6}>
      <Card title="Endereço atual" style={{boxShadow:'none', border:'1px solid #eee',padding:"1rem"}}>
        <div className="tAlignL" style={{lineHeight:'1.6rem',padding:"1rem"}}>
          <div>
            {addressData.current.street}, {addressData.current.number}
            {addressData.current.complement ? ` - ${addressData.current.complement}` : ''}
          </div>
          <div>
            {addressData.current.neighborhood} - {addressData.current.city}/{addressData.current.state} - CEP {addressData.current.zip}
          </div>

          <div style={{marginTop:'0.5rem'}}><small><i className="pi pi-exclamation-triangle" style={{color:"orange",marginRight:"5px"}}></i> Alterar o endereço pode impactar diretamente nos leads.</small></div>
        </div>
      </Card>
    </Grid>
    <Grid item xs={12} sm={6}>
      <Card title="Mapa" style={{boxShadow:'none', border:'1px solid #eee'}}>
        <div style={{width:'100%', height: isMobile ? '220px' : '260px', overflow:'hidden', borderRadius:'8px'}}>
          {(addressData.current.latitude != null && addressData.current.longitude != null) ? (
              <iframe
                title="map"
                width="100%"
                height="100%"
                style={{border:0}}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${addressData.current.latitude},${addressData.current.longitude}&z=15&output=embed`}
              />
            ) : (
              <div style={{padding:'1rem'}} className="tAlignL">
                <small>Mapa indisponível (sem coordenadas cadastradas).</small>
              </div>
            )}
        </div>
      </Card>
    </Grid>

    <Grid item xs={12}>
      <Divider />
      <div className="tAlignL" style={{fontWeight:600, marginBottom:'0.5rem'}}>Substituir endereço</div>
    </Grid>

    {/* form newAddress... (mantém o trecho que já está no arquivo atualizado) */}

<Grid item xs={12} sm={8}>
  <div className="p-float-label">
    <InputText
      id="addressStreet"
      value={addressData.newAddress.street}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, street: e.target.value}}))}
      className="w100"
    />
    <label htmlFor="addressStreet">Logradouro</label>
  </div>
</Grid>

<Grid item xs={12} sm={4}>
  <div className="p-float-label">
    <InputText
      id="addressNumber"
      value={addressData.newAddress.number}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, number: e.target.value}}))}
      className="w100"
    />
    <label htmlFor="addressNumber">Número</label>
  </div>
</Grid>

<Grid item xs={12} sm={6}>
  <div className="p-float-label">
    <InputText
      id="addressComplement"
      value={addressData.newAddress.complement}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, complement: e.target.value}}))}
      className="w100"
    />
    <label htmlFor="addressComplement">Complemento</label>
  </div>
</Grid>

<Grid item xs={12} sm={6}>
  <div className="p-float-label">
    <InputText
      id="addressNeighborhood"
      value={addressData.newAddress.neighborhood}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, neighborhood: e.target.value}}))}
      className="w100"
    />
    <label htmlFor="addressNeighborhood">Bairro</label>
  </div>
</Grid>

<Grid item xs={12} sm={5}>
  <div className="p-float-label">
    <InputText
      id="addressCity"
      value={addressData.newAddress.city}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, city: e.target.value}}))}
      className="w100"
    />
    <label htmlFor="addressCity">Cidade</label>
  </div>
</Grid>

<Grid item xs={12} sm={2}>
  <div className="p-float-label">
    {/*<InputText
      id="addressState"
      value={addressData.newAddress.state}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, state: (e.target.value || '').toUpperCase()} }))}
      className="w100"
    />*/}

      <Dropdown
        id="addressState"
        tabIndex={11} 
        disabled={savingBlocks.businessData} 
        value={addressData.newAddress.state}
        onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, state: (e.target.value || '').toUpperCase()} }))}
        options={ufsList}
        placeholder="UF do endereço"
        style={{ width: "100%", textAlign:"left" }}
      />

    <label htmlFor="addressState">UF</label>
  </div>
</Grid>

<Grid item xs={12} sm={5}>
  <div className="p-float-label">
    <InputText
      id="addressZip"
      value={addressData.newAddress.zip}
      disabled={savingBlocks.address}
      onChange={(e) => setAddressData(prev => ({...prev, newAddress: {...prev.newAddress, zip: e.target.value}}))}
      className="w100"
    />
    <label htmlFor="addressZip">CEP</label>
  </div>
</Grid>

{/*<Grid item xs={12} sm={6}>
  <div className="p-float-label">
    <InputText
      id="addressLat"
      value={String(addressData.latitude ?? '')}
      disabled={savingBlocks.address}
      onChange={(e) => {
        const v = e.target.value.replace(',', '.');
        setAddressData(prev => ({...prev, latitude: v === '' ? '' : v}));
      }}
      className="w100"
    />
    <label htmlFor="addressLat">Latitude</label>
  </div>
</Grid>

<Grid item xs={12} sm={6}>
  <div className="p-float-label">
    <InputText
      id="addressLng"
      value={String(addressData.longitude ?? '')}
      disabled={savingBlocks.address}
      onChange={(e) => {
        const v = e.target.value.replace(',', '.');
        setAddressData(prev => ({...prev, longitude: v === '' ? '' : v}));
      }}
      className="w100"
    />
    <label htmlFor="addressLng">Longitude</label>
  </div>
</Grid>*/}


  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">
      <Button
        label="Gravar alterações"
        icon="pi pi-check"
        loading={savingBlocks.address}
        onClick={() => {
          const a = addressData.newAddress || {};

          const hasMinimum =
            (a.street && a.street.trim()) &&
            (a.number && a.number.trim()) &&
            (a.neighborhood && a.neighborhood.trim()) &&
            (a.city && a.city.trim()) &&
            (a.state && a.state.trim()) &&
            (a.zip && a.zip.trim());

          if (!hasMinimum) {
            setAlertTitle('Atenção');
            setAlertBody('Preencha ao menos: Logradouro, Número, Bairro, Cidade, UF e CEP.');
            setAlert(true);
            return;
          }

          // Monta fullAddress (se o form não tiver input para isso)
          const zipDigits = String(a.zip || '').replace(/\D/g, '');
          const fullAddress =
            `${a.street}, ${a.number}` +
            (a.complement ? ` - ${a.complement}` : '') +
            ` - ${a.neighborhood} - ${a.city}/${String(a.state || '').toUpperCase()} - CEP ${zipDigits}`;

          // Normaliza lat/lng se existirem (hoje o form está comentado; mantém null)
          const latitude =
            a.latitude === '' || a.latitude == null ? null : parseFloat(String(a.latitude).replace(',', '.'));
          const longitude =
            a.longitude === '' || a.longitude == null ? null : parseFloat(String(a.longitude).replace(',', '.'));

          const payload = {
            companyAddress: {
              label: 'Endereço Principal',
              streetType: '',

              streetName: String(a.street).trim(),
              streetNumber: String(a.number).trim(),
              streetComplement: a.complement ? String(a.complement).trim() : null,

              postalCode: zipDigits,
              suburb: String(a.neighborhood).trim(),
              city: String(a.city).trim(),
              state: String(a.state).trim().toUpperCase(),
              country: 'BR',

              fullAddress: fullAddress,
              hasCoordinates: (latitude != null && longitude != null),
              latitude,
              longitude,

              googlePlaceId: a.googlePlaceId || null,
              googleCoordinates: null
            }
          };

          setBlockSaving('address', true);

          updateCompanyAddress(payload, {
            setSuccess: () => {
              // Padrão do projeto: após update, atualiza com retrieve correspondente
              retrieveCompanyAddress({
                setSuccess: (resp) => {
                  const found = !!resp?.found;
                  const d = resp?.data || null;

                  const parsed = found && d ? {
                    id: d.id || null,
                    label: d.label || null,
                    street: d.streetName || '',
                    number: d.streetNumber || '',
                    complement: d.streetComplement || '',
                    neighborhood: d.suburb || '',
                    city: d.city || '',
                    state: d.state || '',
                    zip: d.postalCode || '',
                    fullAddress: d.fullAddress || '',
                    latitude: d.latitude ?? null,
                    longitude: d.longitude ?? null,
                    googlePlaceId: d.googlePlaceId || null,
                    hasCoordinates: (d.latitude != null && d.longitude != null)
                  } : buildEmptyAddress();

                  setAddressData(prev => ({
                    ...prev,
                    current: parsed,
                    newAddress: buildEmptyAddress()
                  }));

                  setBlockSaving('address', false);
                  setAlertTitle('Sucesso');
                  setAlertBody('Endereço atualizado com sucesso.');
                  setAlert(true);
                },
                setError: (message) => {
                  setBlockSaving('address', false);
                  setAlertTitle('Atenção');
                  setAlertBody(message);
                  setAlert(true);
                }
              });
            },
            setError: (message) => {
              setBlockSaving('address', false);
              setAlertTitle('Atenção');
              setAlertBody(message);
              setAlert(true);
            }
          });
        }}

      />
    </div>
  </div>
</Panel>

{/* -------------------------------------------------------------------- */}
{/*  BLOCO 2 - Dados de faturamento                                      */}
{/* -------------------------------------------------------------------- */}
<Panel header="Dados de faturamento" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>
    <Grid item xs={12}>
      <Card title="CNPJ e endereço de faturamento atual" style={{boxShadow:'none', border:'1px solid #eee',padding:"1rem"}}>
        <div className="tAlignL" style={{lineHeight:'1.6rem',padding:"0.5rem"}}>
          <div>
            <b>CNPJ:</b>{' '}0
            {billingData?.current?.billingDocument ? billingData.current.billingDocument : 'Não informado'}
          </div>

          <div>
            <b>Endereço:</b>{' '}
            {billingData?.current?.street
              ? (
                <>
                  {billingData.current.streetType} {billingData.current.street}{billingData.current.number ? `, ${billingData.current.number}` : ''}
                  {billingData.current.complement ? ` - ${billingData.current.complement}` : ''}
                  {billingData.current.neighborhood ? ` - ${billingData.current.neighborhood}` : ''}
                  {billingData.current.city || billingData.current.state ? ` - ${billingData.current.city || ''}/${billingData.current.state || ''}` : ''}
                  {billingData.current.zip ? ` - CEP ${billingData.current.zip}` : ''}
                </>
              )
              : 'Não informado'
            }
          </div>
        </div>
      </Card>
    </Grid>

    <Grid item xs={12}>
      <Divider />
      <div className="tAlignL" style={{fontWeight:600, marginBottom:'0.5rem'}}>
        Atualizar CNPJ e/ou endereço de faturamento
      </div>
    </Grid>

    <Grid item xs={12} sm={5}>
      <div className="p-float-label">
        <InputText
          id="billingNewCnpj"
          value={billingData.newBilling.billingDocument}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: {
                ...prev.newBilling,
                billingDocument: maskCNPJ(e.target.value)
              }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewCnpj">CNPJ - Se não alterar, deixe em branco</label>
      </div>
    </Grid>

    {/* NOVO: Label do endereço (opcional, mas atende seu backend quando enviar endereço) */}
    <Grid item xs={12} sm={7}>
      <div className="p-float-label">
        <InputText
          id="billingNewLabel"
          value={billingData.newBilling.label}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, label: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewLabel">Label do endereço (opcional)</label>
      </div>
    </Grid>

    {/* NOVO: streetType é OBRIGATÓRIO no backend */}
    <Grid item xs={12} sm={4}>
      <div className="p-float-label">
        <InputText
          id="billingNewStreetType"
          value={billingData.newBilling.streetType}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, streetType: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewStreetType">Tipo de logradouro (Rua, Av., etc.)</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={8}>
      <div className="p-float-label">
        <InputText
          id="billingNewStreet"
          value={billingData.newBilling.street}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, street: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewStreet">Logradouro</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={4}>
      <div className="p-float-label">
        <InputText
          id="billingNewNumber"
          value={billingData.newBilling.number}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, number: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewNumber">Número</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText
          id="billingNewComplement"
          value={billingData.newBilling.complement}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, complement: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewComplement">Complemento</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={6}>
      <div className="p-float-label">
        <InputText
          id="billingNewNeighborhood"
          value={billingData.newBilling.neighborhood}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, neighborhood: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewNeighborhood">Bairro</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={5}>
      <div className="p-float-label">
        <InputText
          id="billingNewCity"
          value={billingData.newBilling.city}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, city: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewCity">Cidade</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={2}>
      <div className="p-float-label">
        <InputText
          id="billingNewState"
          value={billingData.newBilling.state}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, state: e.target.value.toUpperCase() }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewState">UF</label>
      </div>
    </Grid>

    <Grid item xs={12} sm={5}>
      <div className="p-float-label">
        <InputText
          id="billingNewZip"
          value={billingData.newBilling.zip}
          onChange={(e) =>
            setBillingData(prev => ({
              ...prev,
              newBilling: { ...prev.newBilling, zip: e.target.value }
            }))
          }
          disabled={savingBlocks.billingData}
          className="w100"
        />
        <label htmlFor="billingNewZip">CEP</label>
      </div>
    </Grid>

  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">
      <Button
        label="Gravar alterações"
        icon="pi pi-check"
        loading={savingBlocks.billingData}

        onClick={() => {
          const b = billingData?.newBilling || {};

          const docRaw = (b.billingDocument || '').trim();
          const docDigits = docRaw ? docRaw.replace(/\D/g, '') : '';

          const hasDoc = !!docDigits;

          const hasAddr =
            !!(b.streetType || b.street || b.number || b.complement || b.neighborhood || b.city || b.state || b.zip);

          if (!hasDoc && !hasAddr) {
            setAlertTitle('Atenção');
            setAlertBody('Preencha o CNPJ e/ou os dados do endereço para atualizar o faturamento.');
            setAlert(true);
            return;
          }

          /// Check if CNPJ is valid
          if (hasDoc && !validarCNPJ(docDigits)) {
            setAlertTitle('Atenção');
            setAlertBody('CNPJ inválido. Verifique o número informado.');
            setAlert(true);
            return;
          }

          // Se endereço for enviado, valida campos obrigatórios do backend
          if (hasAddr) {
            const missing = [];
            const label = (b.label || 'Endereço de Cobrança').trim();

            const streetType = (b.streetType || '').trim();
            const streetName = (b.street || '').trim();
            const streetNumber = (b.number || '').trim();
            const suburb = (b.neighborhood || '').trim();
            const city = (b.city || '').trim();
            const state = (b.state || '').trim();

            if (!label) missing.push('Label');
            if (!streetType) missing.push('Tipo de logradouro');
            if (!streetName) missing.push('Logradouro');
            if (!streetNumber) missing.push('Número');
            if (!suburb) missing.push('Bairro');
            if (!city) missing.push('Cidade');
            if (!state) missing.push('UF');

            // fullAddress obrigatório no backend
            const zip = (b.zip || '').trim();
            const fullAddress = `${streetType} ${streetName}, ${streetNumber}${b.complement ? ' - ' + b.complement : ''} - ${suburb} - ${city}/${state}${zip ? ' - CEP ' + zip : ''}`.trim();

            if (!fullAddress) missing.push('Endereço completo');

            if (missing.length) {
              setAlertTitle('Atenção');
              setAlertBody(`Para atualizar o endereço, preencha: ${missing.join(', ')}.`);
              setAlert(true);
              return;
            }
          }

          const payload = {};

          if (hasDoc) {
            payload.companyBillingDocument = {
              type: 'cnpj',
              value: docDigits
            };
          }

          if (hasAddr) {
            const label = (b.label || 'Endereço de Cobrança').trim();
            const streetType = (b.streetType || '').trim();
            const streetName = (b.street || '').trim();
            const streetNumber = (b.number || '').trim();
            const streetComplement = (b.complement || '').trim() || null;
            const suburb = (b.neighborhood || '').trim();
            const city = (b.city || '').trim();
            const state = (b.state || '').trim();
            const postalCode = (b.zip || '').trim() ? String(b.zip).replace(/\D/g, '') : null;

            const fullAddress = `${streetType} ${streetName}, ${streetNumber}${streetComplement ? ' - ' + streetComplement : ''} - ${suburb} - ${city}/${state}${postalCode ? ' - CEP ' + postalCode : ''}`.trim();

            payload.companyBillingAddress = {
              label,
              streetType,
              streetName,
              streetNumber,
              streetComplement,
              postalCode,
              suburb,
              city,
              state,
              country: 'BR',
              fullAddress,

              // opcionais
              googleCoordinates: b.googleCoordinates || null,
              googlePlaceId: b.googlePlaceId || null,
            };
          }

          setBlockSaving('billingData', true);

          updateCompanyBillingData(payload, {
            setSuccess: (resp) => {
              const addr = resp?.billingAddress || null;
              const doc = resp?.billingDocument || null;

              // Atualiza o "current" com o que veio do backend e limpa o form
              setBillingData((prev) => ({
                ...prev,
                current: {
                  billingDocument: doc?.value ? maskCNPJ(doc.value) : (prev.current?.billingDocument || ''),
                  street: addr?.streetName || (prev.current?.street || ''),
                  streetType: addr?.streetType || (prev.current?.streetType || ''),
                  number: addr?.streetNumber || (prev.current?.number || ''),
                  complement: addr?.streetComplement || (prev.current?.complement || ''),
                  neighborhood: addr?.suburb || (prev.current?.neighborhood || ''),
                  city: addr?.city || (prev.current?.city || ''),
                  state: addr?.state || (prev.current?.state || ''),
                  zip: addr?.postalCode ? String(addr.postalCode) : (prev.current?.zip || ''),
                  country: addr?.country || 'BR',
                  fullAddress: addr?.fullAddress || (prev.current?.fullAddress || ''),
                  googleCoordinates: addr?.googleCoordinates || null,
                  googlePlaceId: addr?.googlePlaceId || null,
                  label: addr?.label || 'Endereço de Cobrança',
                },
                newBilling: {
                  billingDocument: '',
                  label: '',
                  streetType: '',
                  street: '',
                  number: '',
                  complement: '',
                  neighborhood: '',
                  city: '',
                  state: '',
                  zip: '',
                  googleCoordinates: null,
                  googlePlaceId: null,
                }
              }));

              setBlockSaving('billingData', false);
              setAlertTitle('Atualização realizada');
              setAlertBody('Dados de faturamento atualizados com sucesso.');
              setAlert(true);
            },
            setError: (message) => {
              setBlockSaving('billingData', false);
              setAlertTitle('Atenção');
              setAlertBody(message);
              setAlert(true);
            }
          });
        }}

      />
    </div>
  </div>
</Panel>

{/* -------------------------------------------------------------------- */}
{/*  BLOCO 6 - Links e mídias                                            */}
{/* -------------------------------------------------------------------- */}
<Panel header="Links e mídias" style={{marginBottom:"20px"}}>
  <Grid container spacing={5} style={{marginTop:"-20px"}}>

    {/* Website */}
    <Grid item xs={12} sm={6}>
      <span className="p-float-label">
        <InputText
          id="linksWebsite"
          disabled={savingBlocks.linksMedia}
          value={linksMediaData.website}
          onChange={(e) => setLinksMediaData(prev => ({...prev, website: e.target.value}))}
          className="w100"
        />
        <label htmlFor="linksWebsite">Website</label>
      </span>
    </Grid>
    
    
    {/* Redes sociais (dinâmico) */}
    <Grid item xs={12}>
      <div className="tAlignL" style={{fontWeight:600, marginBottom:'0.5rem'}}>Redes sociais</div>

      <small className="tAlignL dBlock" style={{marginBottom:'2rem'}}>
        Adicione as redes sociais que deseja exibir na plataforma.
      </small>

      {linksMediaData.socialLinks?.map((item, index) => (
        <Card key={index} style={{boxShadow:'none', border:'1px solid #eee', marginBottom:'30px'}}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
			<span className="p-float-label">

      <Dropdown
        id={`socialType_${index}`}
        value={item.type}                 // deve ser string (ex.: 'instagram')
        options={socialMediaCatalog}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => {
          const value = e.value;          // string curta
          setLinksMediaData(prev => {
            const socialLinks = [...(prev.socialLinks || [])];
            socialLinks[index] = { ...(socialLinks[index] || {}), type: value };
            return { ...prev, socialLinks };
          });
        }}
        disabled={savingBlocks.linksMedia}
        className="w100"
        placeholder="Selecione"
      />

			<label htmlFor={`socialType_${index}`}>Mídia social</label>
			</span>
            </Grid>

            <Grid item xs={12} sm={7}>
              <span className="p-float-label">
                <InputText
                  id={`socialUrl_${index}`}
                  disabled={savingBlocks.linksMedia}
                  value={item.url}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLinksMediaData(prev => {
                      const socialLinks = [...(prev.socialLinks || [])];
                      socialLinks[index] = {...socialLinks[index], url: value};
                      return {...prev, socialLinks};
                    });
                  }}
                  className="w100"
                />
                <label htmlFor={`socialUrl_${index}`}>URL</label>
              </span>
            </Grid>

            <Grid item xs={12} sm={1} style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
              <Button
                icon="pi pi-trash"
                severity="danger"
                text
                disabled={savingBlocks.linksMedia}
                onClick={() => {
                  setLinksMediaData(prev => ({
                    ...prev,
                    socialLinks: (prev.socialLinks || []).filter((_, i) => i !== index)
                  }));
                }}
                tooltip="Remover"
                tooltipOptions={{ position: 'top' }}
              />
            </Grid>
          </Grid>
        </Card>
      ))}

      <Button
        label="Adicionar rede social"
        icon="pi pi-plus"
        outlined
        disabled={savingBlocks.linksMedia}
        onClick={() => {
          setLinksMediaData(prev => ({
            ...prev,
            socialLinks: [...(prev.socialLinks || []), { type: '', url: '' }]
          }));
        }}
      />
    </Grid>

    
      <Divider />
    

    {/* Telefones adicionais (dinâmico) */}
    <Grid item xs={12}>
      <div className="tAlignL" style={{fontWeight:600, marginBottom:'0.5rem'}}>Telefones adicionais</div>

      <small className="tAlignL dBlock" style={{marginBottom:'2rem'}}>
        Adicione as telefones extras que deseja exibir na plataforma.
      </small>      

      {linksMediaData.additionalPhones?.map((phone, index) => (
        <Card key={index} style={{boxShadow:'none', border:'1px solid #eee', marginBottom:'30px'}}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={11}>
              <span className="p-float-label">
                <InputText
                  id={`additionalPhone_${index}`}
                  disabled={savingBlocks.linksMedia}
                  value={maskPhone(phone || "")}
                  onChange={(e) => {
                      const value = e.target.value;

                      setLinksMediaData(prev => {
                        const additionalPhones = [...(prev.additionalPhones || [])];

                        // Salva o valor como o usuário digita (com máscara ou não),
                        // mas sempre exibimos mascarado no value={maskPhone(...)}.
                        additionalPhones[index] = value;

                        return { ...prev, additionalPhones };
                      });
                    }}
                  className="w100"
                />
                <label htmlFor={`additionalPhone_${index}`}>Telefone</label>
              </span>
            </Grid>

            <Grid item xs={12} sm={1} style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
              <Button
                icon="pi pi-trash"
                severity="danger"
                text
                disabled={savingBlocks.linksMedia}
                onClick={() => {
                  setLinksMediaData(prev => ({
                    ...prev,
                    additionalPhones: (prev.additionalPhones || []).filter((_, i) => i !== index)
                  }));
                }}
                tooltip="Remover"
                tooltipOptions={{ position: 'top' }}
              />
            </Grid>
          </Grid>
        </Card>
      ))}

      <Button
        label="Adicionar telefone"
        icon="pi pi-plus"
        outlined
        disabled={savingBlocks.linksMedia}
        onClick={() => {
          setLinksMediaData(prev => ({
            ...prev,
            additionalPhones: [...(prev.additionalPhones || []), '']
          }));
        }}
      />
    </Grid>

    <Grid item xs={12}>
      <Divider />
    </Grid>

    {/* Emails adicionais (dinâmico) */}
    <Grid item xs={12}>
      <div className="tAlignL" style={{fontWeight:600, marginBottom:'0.5rem'}}>E-mails adicionais</div>

      <small className="tAlignL dBlock" style={{marginBottom:'2rem'}}>
        Adicione as telefones extras que deseja exibir na plataforma.
      </small>            

      {linksMediaData.additionalEmails?.map((mail, index) => (
        <Card key={index} style={{boxShadow:'none', border:'1px solid #eee', marginBottom:'30px'}}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={11}>
              <span className="p-float-label">
                <InputText
                  id={`additionalEmail_${index}`}
                  disabled={savingBlocks.linksMedia}
                  value={mail}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLinksMediaData(prev => {
                      const additionalEmails = [...(prev.additionalEmails || [])];
                      additionalEmails[index] = value;
                      return {...prev, additionalEmails};
                    });
                  }}
                  className="w100"
                />
                <label htmlFor={`additionalEmail_${index}`}>Email</label>
              </span>
            </Grid>

            <Grid item xs={12} sm={1} style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
              <Button
                icon="pi pi-trash"
                severity="danger"
                text
                disabled={savingBlocks.linksMedia}
                onClick={() => {
                  setLinksMediaData(prev => ({
                    ...prev,
                    additionalEmails: (prev.additionalEmails || []).filter((_, i) => i !== index)
                  }));
                }}
                tooltip="Remover"
                tooltipOptions={{ position: 'top' }}
              />
            </Grid>
          </Grid>
        </Card>
      ))}

      <Button
        label="Adicionar e-mail"
        icon="pi pi-plus"
        outlined
        disabled={savingBlocks.linksMedia}
        onClick={() => {
          setLinksMediaData(prev => ({
            ...prev,
            additionalEmails: [...(prev.additionalEmails || []), '']
          }));
        }}
      />
    </Grid>

  </Grid>

  <div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>
    <div className="modalFooterButtonsRight">
      <Button
        label="Gravar alterações"
        icon="pi pi-check"
        loading={savingBlocks.linksMedia}
        onClick={() => {
          // ------------------------------------------------------------
          // Replace-all: SEMPRE enviar todos os nós obrigatórios
          // ------------------------------------------------------------

          const website = (linksMediaData.website || "").toString().trim();

          // socialLinks do frontend: [{type,url}]
            const companySocialMedia = (linksMediaData.socialLinks || [])
              .map((item) => {
                const rawType = item?.type;
                const type =
                  (rawType && typeof rawType === 'object' && rawType.value) ? rawType.value :
                  (rawType || '');

                const key = String(type || '').trim().toLowerCase();
                const url = String(item?.url || '').trim();

                return { key, value: url };
              })
              .filter((x) => x.key && x.value)
              .map((x) => ({
                name: x.key,
                key: x.key,
                value: x.value,
              }));            

          const companyExtraPhones = (linksMediaData.additionalPhones || [])
            .map((p) => String(p || "").trim())
            .filter((p) => p !== "")
            .map((p) => ({
              type: "fixed",
              value: p.replace(/\D/g, ""), // garante dígitos no backend
            }))
            .filter((x) => x.value);

          const companyExtraEmail = (linksMediaData.additionalEmails || [])
            .map((m) => String(m || "").trim().toLowerCase())
            .filter((m) => m !== "")
            .map((m) => ({ value: m }));

            // ------------------------------------------------------------
            // Validação: e-mails adicionais
            // ------------------------------------------------------------
            const filledEmails = (linksMediaData.additionalEmails || [])
              .map(v => String(v || "").trim())
              .filter(v => v !== "");

            const invalidEmails = filledEmails.filter(v => !validarEmail(v));

            if (invalidEmails.length) {
              setAlertTitle("Atenção");
              setAlertBody(
                `Existem e-mails inválidos. Corrija antes de gravar:\n\n- ${invalidEmails.join("\n- ")}`
              );
              setAlert(true);
              return;
            }

            // ------------------------------------------------------------
            // Validação: telefones adicionais
            // ------------------------------------------------------------
            const filledPhones = (linksMediaData.additionalPhones || [])
              .map(v => String(v || "").trim())
              .filter(v => v !== "");

           /* const invalidPhones = filledPhones.filter(v => !validarTelefone(v));0

            if (invalidPhones.length) {
              setAlertTitle("Atenção");
              setAlertBody(
                `Existem telefones inválidos. Corrija antes de gravar:\n\n- ${invalidPhones.join("\n- ")}`
              );
              setAlert(true);
              return;
            } */           

            // ------------------------------------------------------------
            // Validação: url das midias sociais + verifica se URL é válida
            // ------------------------------------------------------------ 
            const validarURL = (url) => {
              const pattern = new RegExp('^(https?:\\/\\/)?' + // protocolo
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domínio
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) endereço
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // porta e caminho
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // consulta
                '(\\#[-a-z\\d_]*)?$', 'i');
              return !!pattern.test(url);
            }
            
            const invalidSocial = (linksMediaData.socialLinks || [])
              .filter(x => (x?.type || "").trim() !== "" || (x?.url || "").trim() !== "")
              .filter(x => !(String(x?.type || "").trim() && String(x?.url || "").trim()));

            // verifica se as URLs são válidas
            const invalidUrls = (linksMediaData.socialLinks || [])
              .map(x => String(x?.url || "").trim())
              .filter(u => u !== "" && !validarURL(u));

            if (invalidUrls.length) {
              setAlertTitle("Atenção");
              setAlertBody(`Existem URLs inválidas. Corrija antes de gravar:\n\n- ${invalidUrls.join("\n- ")}`);
              setAlert(true);
              return;
            }

            if (invalidSocial.length) {
              setAlertTitle("Atenção");
              setAlertBody("Existem redes sociais incompletas. Selecione a mídia e preencha a URL, ou remova a linha.");
              setAlert(true);
              return;
            } 

          const payload = {
            companyWebsite: website === "" ? null : website,
            companySocialMedia: companySocialMedia,      // obrigatorio (envie [] para remover tudo)
            companyExtraPhones: companyExtraPhones,      // obrigatorio (envie [] para remover tudo)
            companyExtraEmail: companyExtraEmail         // obrigatorio (envie [] para remover tudo)
          };

          setBlockSaving("linksMedia", true);

          updateCompanyLinksAndMedia(payload, {
            setSuccess: () => {
              // padrão do projeto: após update, repuxa o retrieve
              retrieveCompanyLinksAndMedia({
                setSuccess: (resp) => {
                  const data = resp?.data || {};

                  setLinksMediaData({
                    website: data?.companyWebsite || "",
                    socialLinks: (data?.companySocialMedia || []).map((item) => ({
                      type: item?.key || "",
                      url: item?.value || "",
                    })),
                    additionalPhones: (data?.companyExtraPhones || []).map((p) => String(p?.value || "")),
                    additionalEmails: (data?.companyExtraEmail || []).map((m) => String(m?.value || "").trim().toLowerCase()),
                  });

                  setBlockSaving("linksMedia", false);
                  setAlertTitle("Sucesso");
                  setAlertBody("Links e mídias atualizados com sucesso.");
                  setAlert(true);
                },
                setError: (message) => {
                  setBlockSaving("linksMedia", false);
                  setAlertTitle("Atenção");
                  setAlertBody(message);
                  setAlert(true);
                },
              });
            },
            setError: (message) => {
              setBlockSaving("linksMedia", false);
              setAlertTitle("Atenção");
              setAlertBody(message);
              setAlert(true);
            },
          });
        }}

      />
    </div>
  </div>
</Panel>

								<AlertView
									alert={alert}
									setAlert={setAlert}
									alertTitle={alertTitle}
									alertBody={alertBody}
									alertAction={alertAction}
									scrollBlock={true}				
								/>
								</Box>
								
									
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
				
    </div>
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  servicesList: store.partnerReducer.servicesList,
  discountsList: store.partnerReducer.discountsList,
  specialitiesList: store.partnerReducer.specialitiesList  
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Users);	


